export const acticonV3dComponentNames = {
  entityReference: 'EntityReferenceComponent',
  sceneLight: 'ActiconSceneLight',
  showEdges: 'ShowModelEdgesComponent',
  interactive: 'ActiconInteractiveComponent'
};
